import { DashboardService } from './dashboard-service';
import Errors from '@/shared/error/errors';

export const GET_DASHBOARDS = 'getDashboards';

export const SET_DASHBOARDS = 'setDashboards';


const state = {
    data: null,
};

const getters = {
    data: (state) => state.data,
    totalApplications: (state) => state.data?.total_applications || null,
    totalApplicationsByType: (state) => state.data?.total_applications_by_type || null,
    applicationsResolutionTermObjective: (state) => state.data?.applications_avg_resolution_goal || null,
    applicationsPerformance: (state) => state.data?.applications_performance || null,
    applicationsAvgResolutionTerm: (_, getters) => getters.applicationsPerformance?.resolution_avg ?? 0,
};

const actions = {
    [GET_DASHBOARDS](context, types) {
        context.commit('shared/activateLoading', 'dashboards/getDashboards', { root: true });
        const params = { params: { dashboard_types: types }};
        return new Promise((resolve) => {
            DashboardService.getData(params)
                .then((data) => {
                    context.commit(SET_DASHBOARDS, data);
                    resolve();
                })
                .catch(error => {
                    Errors.handle(error);
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'dashboards/getDashboards', { root: true });
                });
        });
    },
};

const mutations = {
    [SET_DASHBOARDS](state, data) {
        state.data = data;
    },
};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
